import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const CompleteWizardCheckIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 35 35", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <polygon
                    fill="#FFFFFF"
                    points="20.9,13.5 16.5,19.3 14,16.8 12.5,18.3 16.8,22.5 22.6,14.7 	"
                />
                <path
                    fill="#6EEDB8"
                    d="M17.5,0.5c-9.4,0-17,7.6-17,17s7.6,17,17,17s17-7.6,17-17S26.9,0.5,17.5,0.5z M12.5,18.3l1.5-1.5l2.5,2.5
		l4.4-5.8l1.7,1.3l-5.8,7.8L12.5,18.3z"
                />
            </g>
        </SvgIcon>
    );
};
